import { useCallback, useEffect, useSyncExternalStore } from 'react';
import { IMAGE_STATUS, imageCache, ImageState } from '@/contexts/ai-image-cache';

export function useAiImage(key: string, loader: () => Promise<string>): ImageState {
	const subscribe = useCallback((notify: () => void) => imageCache.addSubscriber(key, notify), [key]);
	const getSnapshot = useCallback(() => imageCache.getImageStateByKey(key), [key]);
	const state = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

	useEffect(() => {
		if (state.status === IMAGE_STATUS.IDLE) {
			void imageCache.fetch(key, loader);
		}
	}, [key, loader, state.status]);

	return state;
}
